module.exports = __webpack_public_path__ + "img/kebijakan.d7efc18d.svg";